import { Team } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";
import { PersistTeamResult } from "./TeamsTypes";
import {
  fetchAllList,
  fetchListPage,
  PaginatedListRequest,
  PaginatedListResponse
} from "../utils/PaginatedListService";

export interface TeamService {
  fetch(): Promise<Team[]>;
  fetchPage(request?: PaginatedListRequest): Promise<PaginatedListResponse<Team>>;
  delete(id: string): Promise<void>;
  persist(item: Team): Promise<PersistTeamResult>;
}

class HTTPTeamService implements TeamService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<Team[]> {
    return fetchAllList<Team>(`${this.endpoint}/teams`, (url) =>
      fetchService.fetch(url).then((r) => r.json())
    ).catch((): any[] => []);
  }

  async fetchPage(
    request: PaginatedListRequest = {}
  ): Promise<PaginatedListResponse<Team>> {
    return fetchListPage<Team>(
      `${this.endpoint}/teams`,
      (url) => fetchService.fetch(url).then((r) => r.json()),
      request
    ).catch(() => ({ items: [] as Team[] }));
  }

  async delete(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/teams/${id}`, {
        method: "DELETE",
      })
      .then();
  }

  async persist(item: Team): Promise<PersistTeamResult> {
    return fetchService
      .fetch(`${this.endpoint}/teams`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then((r) => r.json());
  }
}

const regionService: TeamService = new HTTPTeamService(env.endpoint);

export default regionService;
